import React, {useEffect, useState, useCallback} from 'react';
import {StyleSheet, Text} from 'react-native';
import {IRequest} from 'src/domains';
import {Banner, BannerLayout} from './Banner';
import {colors} from 'src/assets';
import {minutesToTime, secondsToTime} from '../utils';
import {useCallActions} from 'src/hooks';
import {CallDataRow} from 'src/components';
import LocalText from 'src/local';

export type WaitingAnswerBlockProps = {
  call: IRequest;
  bannerType: BannerLayout;
  comment?: string;
};

export const WaitingAnswerBlock: React.FC<WaitingAnswerBlockProps> = ({
  call,
  bannerType,
  comment,
}) => {
  const [countDown, setCountDown] = useState<string>('');
  const {timeoutCallRequest} = useCallActions();
  const cancelByTimeout = useCallback(() => {
    if (
      bannerType !== BannerLayout.WaitingTalkConnectionByReceiver &&
      bannerType !== BannerLayout.WaitingTalkConnectionBySender
    ) {
      timeoutCallRequest({id: call.id});
    }
  }, [call, bannerType]);
  useEffect(() => {
    let interval = setInterval(() => {
      if (!call.expiredAt) {
        clearInterval(interval);
        // TODO: Maybe leak
        return;
      }
      const expiredAt = new Date(call.expiredAt);
      const diff = expiredAt.getTime() - Date.now();
      if (diff < 0) {
        clearInterval(interval);
        setCountDown(secondsToTime(0));
        cancelByTimeout();
        return;
      }
      const seconds = Math.floor(diff / 1000);
      setCountDown(secondsToTime(seconds));
    }, 1000);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [call, cancelByTimeout]);
  return (
    <React.Fragment>
      <Banner
        containerStyle={styles.banner}
        layout={bannerType}
        countDown={countDown}
        maxTime={minutesToTime(call.waitingTime)}
      />
      <Text style={styles.description}>
        {LocalText.screens.call.waitingAnswerBlock.description}
      </Text>
      {comment ? <CallDataRow leftIcon={'comment'} text={comment} /> : null}
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  banner: {
    marginHorizontal: 16,
    marginVertical: 8,
  },
  description: {
    marginHorizontal: 16,
    marginVertical: 8,
    fontSize: 12,
    color: colors.chokuBlack,
    lineHeight: 13,
  },
});
